import { Pipe, PipeTransform } from '@angular/core';

/**
 * Highlight Pipe
 *
 * Wraps matched substrings in <mark> tags for visual highlighting.
 * Used with safeHtml pipe: [innerHTML]="text | highlight:term | safeHtml"
 */
@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {

  /** Wrap all occurrences of `searchTerm` in the given `value` with a <mark> tag. */
  transform(value: string | null | undefined, searchTerm: string | null | undefined): string {
    if (!value) return '';
    if (!searchTerm || !searchTerm.trim()) return value;

    // Escape regex special characters in the search term
    const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');

    return value.replace(regex, '<mark class="search-highlight">$1</mark>');
  }
}
